import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

import type { NavigateFunction } from 'react-router-dom';

import { API as api } from 'Backend';
import { getPermissions, setCurrentCompanyId } from 'Lib/Utils';

const platform = Capacitor.getPlatform();
const isMobileApp = platform === 'ios' || platform === 'android';

const addDeviceToUser = async (token: string) => {
    const addDeviceForNotifications = await api.addDeviceForNotifications({ token, platform });
    console.log('addDeviceForNotifications ', JSON.stringify(addDeviceForNotifications));
};

export const registerNotifications = async () => {
    if (!isMobileApp) {
        return false;
    }
    console.log('Request push notification access');
    let permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
    }
    if (permStatus.receive !== 'granted') {
        console.log('User denied permissions!');
        return false;
    }
    await PushNotifications.register();
    return true;
};

export const notificationListeners = async (history: NavigateFunction) => {
    if (!isMobileApp) {
        return false;
    }

    console.log('Listening for various notification events');
    await PushNotifications.addListener('registration', (token) => {
        console.info('Registration token: ', token?.value);
        if (token?.value) {
            addDeviceToUser(token.value);
        }
    });

    await PushNotifications.addListener('registrationError', (err) => {
        console.error('Registration error: ', err.error);
    });

    await PushNotifications.addListener('pushNotificationReceived', (notification) => {
        console.log('Push notification received: ', notification);
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', async (notification) => {
        const data = notification?.notification?.data;
        const deepLink = data?.aps?.alert?.deepLink || data?.deepLink;
        console.log('Push notification action performed', notification);
        if (deepLink) {
            await getCompanyFromQueryParams(deepLink);
            console.log('Redirecting to route: ', deepLink);
            history(deepLink);
        }
    });
    return true;
};

const getCompanyFromQueryParams = async (deepLink: string) => {
    // Check if companyid is in the query string
    const companyId = deepLink.split('companyid=')?.[1];
    if (companyId && getPermissions(companyId)) {
        setCurrentCompanyId(companyId);
    }
};
